import { DataQueryController } from "ui-common";
import { AppContextController, appContext } from "ui-common/appContext.ts";
import { WowRouter, initRouter } from "ui-components/router/wow-router";

import { AppLayout } from "./components/app-layout/app-layout";
import { AnalyticsPage, LinksPage, PostsPage, ProfilePage, SettingsPage, WowPage404 } from "./pages";
import { EmailConfirmationPage } from "./pages/email-confirmation";
import { ForgotPasswordPage } from "./pages/forgot-password";
import { ResetPasswordPage } from "./pages/reset-password";
import { SignInPage } from "./pages/sign-in";
import { SignUpPage } from "./pages/sign-up";
import { OnboardCreatorPage } from "./pages/onboard-creator/onboard-creator";
import { WorldsPage } from "./pages/worlds-page";
import { profileDataQueryOptions } from "./queries/profile-data";

await appContext.ready;

function getRouter() {
  const routerModule = initRouter(
    {
      "sign-in": { page: SignInPage, isDefault: true, layout: undefined, title: "Sign In" },
      "sign-up": { page: SignUpPage, layout: undefined, title: "Sign Up" },
      "onboard-creator": { page: OnboardCreatorPage, layout: undefined },
      "onboard-creator?step=1": { page: OnboardCreatorPage, layout: undefined },
      "sign-up/confirm-email": { page: EmailConfirmationPage, layout: undefined },
      "email-confirmation": { page: EmailConfirmationPage, layout: undefined, title: "Email Confirmation" },
      "forgot-password": { page: ForgotPasswordPage, layout: undefined, title: "Reset Password" },
      "reset-password": { page: ResetPasswordPage, layout: undefined, title: "Reset Password" },
      "404": { page: WowPage404, is404: true, layout: undefined, title: "Page Not Found" },
      profile: { page: ProfilePage, isPrivate: true, title: "Profile" },
      links: { page: LinksPage, isPrivate: true, title: "Links" },
      worlds: { page: WorldsPage, isPrivate: true, title: "Worlds" },
      "worlds/posts": { page: PostsPage, isPrivate: true, title: "World Posts" },
      analytics: { page: AnalyticsPage, isPrivate: true, title: "Analytics" },
      settings: { page: SettingsPage, isPrivate: true, title: "Account Settings" },
    },
    AppLayout,
  );

  function getCurrentUser() {
    return appContext.currentUser as { id: string; name: string; roles: [string] } | undefined;
  }

  routerModule.router.currentUser = getCurrentUser();

  const ctl = new AppContextController(routerModule.router);
  const profileCtl = new DataQueryController(routerModule.router, () => profileDataQueryOptions);

  ctl.beforeUserChanged = () => {
    routerModule.router.currentUser = getCurrentUser();

    if (routerModule.router.currentUser != undefined && profileCtl.query != undefined) {
      profileCtl.query.invalidate();
    }

    if (routerModule.router.currentRoute === "sign-in") {
      navigateTo("profile");
    }
  };

  return routerModule;
}

export const { router, navigateTo } = getRouter();

export type RoutePath = typeof router extends WowRouter<infer T> ? keyof T : never;
